import React from 'react';
import { Link } from 'react-router-dom';

const NavBrand = () => {
    return (
        <Link 
            to="/" 
            className="flex flex-col items-center space-y-1 group"
            aria-label="Hospital System"
             >
            <p className="text-sm text-gray-500 select-none group-hover:text-gray-700 transition-colors">
                Your Health, Our Priority
            </p>
        </Link>
    );
}

export default NavBrand;
